import { render, staticRenderFns } from "./DashboardStatCard.vue?vue&type=template&id=2a8b586b&scoped=true"
import script from "./DashboardStatCard.vue?vue&type=script&lang=ts"
export * from "./DashboardStatCard.vue?vue&type=script&lang=ts"
import style0 from "./DashboardStatCard.vue?vue&type=style&index=0&id=2a8b586b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8b586b",
  null
  
)

export default component.exports